export default {
	styleOverrides: {
		root: {
			'& .MuiInputBase-root': {
				borderRadius: '10px',
				background: '#FFF',
				overflow: 'hidden',
				boxShadow: '5px 4px 10.8px 0px rgba(166, 203, 245, 0.28)',
				border: 'none',
			},

			'& .MuiOutlinedInput-notchedOutline': {
				border: 'none',
			},
		},
		label: {},
		icon: {},
	},
};
